/**
 * Floating share button – opens share stats modal.
 * Fixed position, visible on authenticated pages.
 */

import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ShareStatsModal from './ShareStatsModal';
import './FloatingShareButton.css';

export default function FloatingShareButton() {
  const { currentUser } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);

  if (!currentUser) return null;

  return (
    <>
      <button
        type="button"
        className="floating-share-btn"
        onClick={() => setModalOpen(true)}
        aria-label="Share your stats"
        title="Share your stats"
      >
        <span className="floating-share-btn-icon" aria-hidden>📤</span>
      </button>
      <ShareStatsModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
